import { green } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

// Consolidating colors from index.css and Landing/styles.ts
const colors = {
    ink: "#0A0B2E",
    inkDeep: "#0e1050",
    deep: "#17145F",
    deep2: "#1C186B",
    purple: "#6b3bff",
    cyan: "#33d7ff",
    greenBot: "#51e8bab8",
    white: "#ffffff",
    slate: "#E8E9F7",
    tile: "#5D3CCB",
};

const theme = createTheme({
    palette: {
        primary: {
            main: colors.deep,
            light: colors.deep2,
        },
        // You may define secondary, background, and text similarly or remove them if not used
        // You can extend the palette with custom colors if needed
        custom: {
            ink: {
                main: colors.ink,
                deep: colors.inkDeep,
            },
            deep: {
                main: colors.deep,
                dark: colors.deep2,
            },
            slate: colors.slate,
            tile: colors.tile,
            purple: colors.purple,
            cyan: colors.cyan,
            greenBot: colors.greenBot
        }
    },
    typography: {
        fontFamily: "'Montserrat', 'Poppins', system-ui, -apple-system, Segoe UI, Roboto, Arial",
        h1: {
            fontFamily: "'Montserrat', 'Poppins', system-ui, -apple-system, Segoe UI, Roboto, Arial",
            fontWeight: 800,
            fontSize: '4.125rem', // 66px
            lineHeight: 1,
            letterSpacing: 1,
            textTransform: 'uppercase',
        },
        h2: {
            fontFamily: "'Montserrat', 'Poppins', system-ui, -apple-system, Segoe UI, Roboto, Arial",
            fontWeight: 800,
            fontSize: '1.5rem', // 24px
        },
        subtitle1: {
            fontFamily: "'Montserrat', 'Poppins', system-ui, -apple-system, Segoe UI, Roboto, Arial",
            fontWeight: 600,
            fontSize: '0.875rem', // 14px
        },
        body1: {
            fontFamily: "'Montserrat', 'Poppins', system-ui, -apple-system, Segoe UI, Roboto, Arial",
            fontSize: '1rem', // 16px
        },
        button: {
            fontFamily: "'Montserrat', 'Poppins', system-ui, -apple-system, Segoe UI, Roboto, Arial",
            fontWeight: 800,
            fontSize: '0.9375rem', // 15px
        },
        // Adding custom variants from landing styles
        ui: {
            fontFamily: "'Montserrat', 'Poppins', system-ui, -apple-system, Segoe UI, Roboto, Arial",
            fontWeight: 600,
        },
        uiBold: {
            fontFamily: "'Montserrat', 'Poppins', system-ui, -apple-system, Segoe UI, Roboto, Arial",
            fontWeight: 800,
        },
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: `
                body {
                    margin: 0;
                    -webkit-font-smoothing: antialiased;
                    -moz-osx-font-smoothing: grayscale;
                }
            `,
        },
    },
});

// Extending Theme type for custom properties
declare module '@mui/material/styles' {
    interface Palette {
        custom: {
            ink: {
                main: string;
                deep: string;
            };
            deep: {
                main: string;
                dark: string;
            };
            slate: string;
            tile: string;
            purple: string;
            cyan: string;
            greenBot: string;
        };
    }
    interface PaletteOptions {
        custom?: {
            ink?: {
                main: string;
                deep: string;
            };
            deep?: {
                main: string;
                dark: string;
            };
            slate?: string;
            tile?: string;
            purple?: string;
            cyan?: string;
            greenBot?: string;
        };
    }
    interface TypographyVariants {
        ui: React.CSSProperties;
        uiBold: React.CSSProperties;
    }
    interface TypographyVariantsOptions {
        ui?: React.CSSProperties;
        uiBold?: React.CSSProperties;
    }
}

declare module '@mui/material/Typography' {
    interface TypographyPropsVariantOverrides {
        ui: true;
        uiBold: true;
    }
}


export default theme;
